"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequestError = void 0;
class HttpRequestError extends Error {
    constructor(message, status, cause) {
        super(message);
        this.message = message;
        this.status = status;
        this.cause = cause;
        if (cause) {
            this.cause = cause;
        }
    }
}
exports.HttpRequestError = HttpRequestError;
class FetchHttpClient {
    constructor(baseUrl, sdkParams, timeout) {
        this.baseUrl = baseUrl;
        this.sdkParams = sdkParams;
        this.timeout = timeout;
    }
    async get(resource) {
        const url = new URL(this.baseUrl + resource);
        Object.entries(this.sdkParams).forEach(([key, value]) => url.searchParams.append(key, value));
        try {
            // Canonical implementation of abortable fetch for interrupting when request takes longer than desired.
            // https://developer.chrome.com/blog/abortable-fetch/#reacting_to_an_aborted_fetch
            const controller = new AbortController();
            const signal = controller.signal;
            const timeoutId = setTimeout(() => controller.abort(), this.timeout);
            const response = await fetch(url.toString(), { signal: signal });
            // Clear timeout when response is received within the budget.
            clearTimeout(timeoutId);
            if (!response.ok) {
                throw new HttpRequestError('Failed to fetch data', response.status);
            }
            return response.json();
        }
        catch (error) {
            if (error.name === 'AbortError') {
                throw new HttpRequestError('Request timed out', 408, error);
            }
            else if (error instanceof HttpRequestError) {
                throw error;
            }
            throw new HttpRequestError('Network error', 0, error);
        }
    }
}
exports.default = FetchHttpClient;
//# sourceMappingURL=http-client.js.map